import { useEffect, useRef } from 'react';
import { HighFiveButton } from '../../../shared/components/HighFiveButton';
import { OllieFloating } from '../../../shared/components/OllieFloating';
import { SpeechBubble } from '../../../shared/components/SpeechBubble';
import { AuthStatus, useAuth } from '../../../shared/hooks/Auth';
import { useOnboardingStore } from '../hooks/useOnboardingStore';

interface DrawAHeartCommitmentProps {
    onContinue: () => void;
    isDisabled: boolean;
    onSpeechBubbleComplete: () => void;
}

export const DrawAHeartCommitment = ({ onContinue, isDisabled, onSpeechBubbleComplete }: DrawAHeartCommitmentProps) => {
    const { authStatus } = useAuth();
    const hasInitiatedReferralCode = useRef<boolean>(false);
    const referralCode = useOnboardingStore(state => state.referralCode);
    const checkReferralCode = useOnboardingStore(state => state.checkReferralCode);

    const referralCodeRef = useRef<Promise<void> | null>(null);
    useEffect(() => {
        const initReferralCode = async () => {
            if (authStatus !== AuthStatus.AuthenticatedReady || hasInitiatedReferralCode.current) {
                return;
            }
            hasInitiatedReferralCode.current = true;

            if (!referralCode) {
                return;
            }
            try {
                await checkReferralCode(referralCode);
            } catch (error) { // prevent onboarding from failing if referral code check fails
                console.error('Error checking referral code', error);
            }
        };
        referralCodeRef.current = initReferralCode();
    }, [authStatus, referralCode, checkReferralCode]);


    const onContinueHandler = async () => {
        if (referralCodeRef.current) {
            await referralCodeRef.current;
        }
        await onContinue();
    }

    return (
        <div className='flex flex-col gap-10 safe-pb-4 px-8 flex-1 overflow-hidden'>
            <title>Extra Courage?</title>
            <div className='flex-1 flex flex-col justify-center items-center'>
                <div className='flex flex-col items-center justify-end overflow-show h-[250px]'>
                    <SpeechBubble
                        text="Tackling OCD takes guts and a bit of commitment. Ready to take that first step?"
                        onTypingComplete={onSpeechBubbleComplete}
                    />
                    <OllieFloating />
                </div>
            </div>
            <div className="flex flex-col items-center justify-end gap-4 flex-shrink-0 relative z-10 min-h-[260px]">
                <div className="w-full flex flex-col justify-end">
                </div>
                <HighFiveButton
                    disableButton={isDisabled}
                    emoji="💪"
                    title="Give me Five! You're doing great!"
                    handleHighFive={onContinueHandler}
                />
            </div>
        </div>
    );
};
